import Vue from 'vue';
import VueI18n from 'vue-i18n';

import enGB from '../content/translations/en-GB.json';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en-GB',
    messages: {
        'en-GB': enGB,
    },
});